import React, { useEffect, useState } from "react";
import SisLoader from "../../../../widgets/loader";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import BoilerDetailsTable from "../components/BoilerRow";

function StaffBoiler({ id }) {
  const [loader, setLoader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const fetchBoilerList = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("ship_id", id);

    try {
      const res = await post(ApiURL.list_ship_boiler_details_st, formData);
      if (res?.status === true) {
        setFilteredData(res?.response_data || []);
      }
    } catch (error) {
      console.error("Error fetching ship list:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchBoilerList();
  }, []);

  return (
    <>
      <h3 style={{ margin: "15px 0", fontWeight: "600" }}>Boiler Information</h3>
      {loader ? (
        <SisLoader />
      ) : filteredData.length > 0 ? (
        <BoilerDetailsTable data={filteredData} />
      ) : (
        <p>No data available</p>
      )}
    </>
  );
}

export default StaffBoiler;
